import { render, staticRenderFns } from "./BonoMovimiento.vue?vue&type=template&id=54990a2b"
import script from "./BonoMovimiento.vue?vue&type=script&lang=js"
export * from "./BonoMovimiento.vue?vue&type=script&lang=js"
import style0 from "./BonoMovimiento.vue?vue&type=style&index=0&id=54990a2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports